import React from "react";
import { useStateSelector } from "utils/field"
import EyeOpen from "assets/images/icons/JSX/Eye-Open";
import EyeClosed from "assets/images/icons/JSX/Eye-Closed";
import classes from "./RowToggle.module.scss";

const RowToggle = ({ className, rowId, change }) => {
    const accessor = `community.community.communityDetails.uiSettings`;

    const { upgrades: { hiddenRows = {} } = {} } = useStateSelector(`${accessor}`) || {};

    const hidden = hiddenRows[rowId];

    const toggleRow = () => {
        change(`${accessor}.upgrades.hiddenRows.${rowId}`, !hidden);
    };

    return (
        <span className={className} onClick={toggleRow}>
            {hidden ? (
                <EyeClosed className={classes.eyeIconClosed} />
            ) : (
                <EyeOpen className={classes.eyeIcon} />
            )}
        </span>
    );
};

export default RowToggle;
